import clsx from 'clsx';
import type { ReactNode } from 'react';

export function StatCard({
  label,
  value,
  hint,
  tone = 'default',
  icon,
  className,
}: {
  label: ReactNode;
  value: ReactNode;
  hint?: ReactNode;
  tone?: 'default' | 'good' | 'warn' | 'bad';
  icon?: ReactNode;
  className?: string;
}) {
  const valueTone =
    tone === 'good'
      ? 'text-emerald-400'
      : tone === 'warn'
        ? 'text-amber-400'
        : tone === 'bad'
          ? 'text-red-400'
          : 'text-zinc-50';
  return (
    <div
      className={clsx(
        'min-w-0 rounded-xl border border-zinc-800 bg-zinc-900/50 p-3 shadow-sm shadow-black/20',
        className,
      )}
    >
      <div className="flex items-center justify-between gap-2">
        <span className="truncate text-[11px] font-medium uppercase tracking-wide text-zinc-500">
          {label}
        </span>
        {icon ? <span className="shrink-0 text-zinc-600">{icon}</span> : null}
      </div>
      <div className={clsx('tabular mt-1 truncate text-xl font-semibold sm:text-2xl', valueTone)}>
        {value}
      </div>
      {hint ? <div className="mt-0.5 truncate text-[11px] text-zinc-500">{hint}</div> : null}
    </div>
  );
}

export function StatGrid({ children, className }: { children: ReactNode; className?: string }) {
  return (
    <div className={clsx('grid grid-cols-2 gap-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6', className)}>
      {children}
    </div>
  );
}
